import(/* webpackMode: "eager" */ "/root/mrbuttonv1/client/components/panier/CommandeContainer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/mrbuttonv1/client/components/panier/CommandeStatus.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/mrbuttonv1/client/components/panier/PanierSelector.jsx");
